/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DropdownIcon = ({ width = 24, height = 24, hidden = false, title = 'Dropdown' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M30.5 2h-27A1.5 1.5 0 0 0 2 3.5v4.963a1.5 1.5 0 0 0 1.5 1.5h27a1.5 1.5 0 0 0 1.5-1.5V3.5A1.5 1.5 0 0 0 30.5 2ZM25 8.764l-3.72-4.038a.432.432 0 0 1 .332-.708H28.4a.432.432 0 0 1 .332.708ZM30.5 12h-27A1.5 1.5 0 0 0 2 13.5v19A1.5 1.5 0 0 0 3.5 34h27a1.5 1.5 0 0 0 1.5-1.5v-19a1.5 1.5 0 0 0-1.5-1.5ZM6 15.75a.75.75 0 0 1 .75-.75h20.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75Zm22 13.5a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75h20.5a.75.75 0 0 1 .75.75Zm-2-6a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75h18.5a.75.75 0 0 1 .75.75Z"
    />
  </svg>`;
};
